<div class="px-3">
  <a (click)="onClickAdminCms()" class="btn btn-flex flex-start btn-custom overflow-hidden text-nowrap px-0 h-40px w-100">
    <span [inlineSVG]="'./assets/media/icons/ic_account.svg'" class="svg-icon svg-icon-2 m-0"></span>
    <span class="btn-label px-3"> Admin CMS </span>
  </a>
  <div class="btn-custom pt-2">
    <span class="btn-label text-muted">version {{ APP_VERSION }}</span>
  </div>
</div>
